export default __webpack_public_path__ + "static/media/peekaboo-monkey.ad2f58f8.png";